module.exports = __webpack_public_path__ + "static/media/logoblackwhite72dpi-transparent.0dfebd9c.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/logoblackwhite72dpi-transparent.png
// module id = 402
// module chunks = 0